import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { LoadingStatusWrapper } from 'sharedComponents/WithLoadingStatus';
import PowertrainOverviewComponent from './PowertrainOverviewComponent';
import * as actions from './actions';
import { getModel } from './selectors';
import { setSelectedAssetAction } from '../AssetOverview/actions';

const PowertrainOverviewContainer = (props) => {
    /*useEffect(() => {
        return () => {
            props.actions.clearStore();
        };
    }, []);*/

    return <LoadingStatusWrapper useCustomAnchor loadingStatus={[
        ...props.generalFilterLoadingStatuses
    ]}>
        <PowertrainOverviewComponent {...props} />
    </LoadingStatusWrapper>;
};

PowertrainOverviewContainer.propTypes = {
    actions: PropTypes.shape({
        clearStore: PropTypes.func
    }),
    generalFilterLoadingStatuses: PropTypes.array
};

const mapStateToProps = (state) => {
    const model = getModel(state);
    return {
        model
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators({ ...actions, setSelectedAssetAction }, dispatch)
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PowertrainOverviewContainer);
